var _defs, _rect, _path, _path2, _path3, _path4, _circle, _ellipse, _ellipse2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel4C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5,.cls-7{fill:none;}.cls-2,.cls-3,.cls-4,.cls-6{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke:#000;}.cls-2,.cls-3,.cls-6,.cls-7{stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-width:0.81px;}.cls-3{stroke-width:0.81px;}.cls-4,.cls-5{stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.21,
    width: 227,
    height: 457
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.57,364.82l-6.71,3.58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.63,368.93q-2.37,3-4.75,5.95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.5,357.74,155,363"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.22,349.76l7.13,2.67"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 104.98,
    cy: 231.17,
    r: 33.49
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.86,
    cy: 238.73,
    rx: 2.89,
    ry: 4.04,
    transform: "translate(-102.43 86.49) rotate(-29.36)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.48,
    cy: 228.82,
    rx: 2.89,
    ry: 4.04,
    transform: "translate(-95.3 93.86) rotate(-29.36)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.85,198.8a83.09,83.09,0,0,1-5.33,63.61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.15,225.74a32.54,32.54,0,0,0,25.92-17.24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.64,346.47l-1.38,23.84a8.61,8.61,0,0,0,10.07,9L194.2,358.4a8.61,8.61,0,0,0,4.87-14.29l-15.53-17a8.64,8.64,0,0,0-6.94-2.79A746.37,746.37,0,0,0,72.41,338.54,8.59,8.59,0,0,0,65.64,346.47Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.67,285.61a12.67,12.67,0,0,0-8.41,3.92,1.11,1.11,0,0,0-.41.9c.09.46.61.63,1,.71a57,57,0,0,0,10.45,1.31,18.71,18.71,0,0,0,10-2.58C89.66,286.35,84.45,285.39,80.67,285.61Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.58,289.86c0,30.44,3,40.68,14.36,55.77a43.5,43.5,0,0,0,5.46,5.73,9,9,0,0,0,6.75,2.17c4.24-.36,6-2.53,6-7,0-2.41-1.69-4.77-2.39-7.09l3.54,1a5.73,5.73,0,0,0,1.92.32,2,2,0,0,0,1.63-.92,1.93,1.93,0,0,0-.16-1.87,5.08,5.08,0,0,0-1.4-1.37c-2.46-1.81-6.44-3-9.3-4.07-16.07-13.08-12.48-27-12.48-44.35"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.24,278.65a38.09,38.09,0,0,0-9.28,2.16,13,13,0,0,0-7,6.17,44.63,44.63,0,0,0,14.32-4.86,6.65,6.65,0,0,0,1.8-1.29,2.43,2.43,0,0,0,.65-2.05C150.41,278.8,150.1,278.82,150.24,278.65Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.7,285.08c8,23.83,7.17,31.4-.56,40.22,0,0,.08-.59,0,0a15.82,15.82,0,0,0-6.72,3.78,5.46,5.46,0,0,0-1.21,1.54,2.3,2.3,0,0,0-.08,1.92,2.5,2.5,0,0,0,2.61,1.17,8.86,8.86,0,0,0,2.82-1.16c.59-.31,1.2-.6,1.81-.87,0,.69-.07,1.38-.06,2.07.05,3.42-.61,6.71,1.61,9.31s7.51,3.38,10.7,2.15c3.63-1.4,6.61-5.49,8.67-13.69a85.09,85.09,0,0,0,2-22.56c-.58-9.74-4.44-19.06-9.57-28.58"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M126.27,247.39a9.47,9.47,0,0,0,6.1-5.42"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M81.25,254.65a40.42,40.42,0,0,0,2.08,8.85A13.6,13.6,0,0,0,89,270.44a11.28,11.28,0,0,0,9.42.59,14,14,0,0,0,7.13-6.34"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M138.65,227.4a9.92,9.92,0,0,1-2.94,17.23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel4C);
export default __webpack_public_path__ + "static/media/Idea_Panel_4c.7412f53dbcadfd6c89aa79cc138a1fe5.svg";
export { ForwardRef as ReactComponent };